import { SVGProps } from 'react';

const ShopifyFlowIcon = ({ ...props }: SVGProps<SVGSVGElement>) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M11.5 6.5C11.5 7.32843 10.8284 8 10 8C9.17157 8 8.5 7.32843 8.5 6.5C8.5 5.67157 9.17157 5 10 5C10.8284 5 11.5 5.67157 11.5 6.5Z"
        fill="#0094D5"
      />
      <path
        d="M8 13.5C8 14.3284 7.32843 15 6.5 15C5.67157 15 5 14.3284 5 13.5C5 12.6716 5.67157 12 6.5 12C7.32843 12 8 12.6716 8 13.5Z"
        fill="#0094D5"
      />
      <path
        d="M13.5 15C14.3284 15 15 14.3284 15 13.5C15 12.6716 14.3284 12 13.5 12C12.6716 12 12 12.6716 12 13.5C12 14.3284 12.6716 15 13.5 15Z"
        fill="#0094D5"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M2.43597 4.18404C2 5.03969 2 6.15979 2 8.4V11.6C2 13.8402 2 14.9603 2.43597 15.816C2.81947 16.5686 3.43139 17.1805 4.18404 17.564C5.03969 18 6.15979 18 8.4 18H11.6C13.8402 18 14.9603 18 15.816 17.564C16.5686 17.1805 17.1805 16.5686 17.564 15.816C18 14.9603 18 13.8402 18 11.6V8.4C18 6.15979 18 5.03969 17.564 4.18404C17.1805 3.43139 16.5686 2.81947 15.816 2.43597C14.9603 2 13.8402 2 11.6 2H8.4C6.15979 2 5.03969 2 4.18404 2.43597C3.43139 2.81947 2.81947 3.43139 2.43597 4.18404ZM12.5 6.5C12.5 7.88071 11.3807 9 10 9C9.7757 9 9.55831 8.97046 9.35149 8.91506L8.04271 11.5326C8.62558 11.9903 9 12.7014 9 13.5C9 14.8807 7.88071 16 6.5 16C5.11929 16 4 14.8807 4 13.5C4 12.1193 5.11929 11 6.5 11C6.7243 11 6.94169 11.0295 7.14851 11.0849L8.45729 8.46738C7.87442 8.00969 7.5 7.29857 7.5 6.5C7.5 5.11929 8.61929 4 10 4C11.3807 4 12.5 5.11929 12.5 6.5ZM12.4472 9.77639C12.3237 9.5294 12.0234 9.42929 11.7764 9.55279C11.5294 9.67628 11.4293 9.97662 11.5528 10.2236L12.1415 11.401C11.4545 11.8465 11 12.6202 11 13.5C11 14.8807 12.1193 16 13.5 16C14.8807 16 16 14.8807 16 13.5C16 12.1193 14.8807 11 13.5 11C13.3558 11 13.2144 11.0122 13.0768 11.0357L12.4472 9.77639Z"
        fill="#0094D5"
      />
    </svg>
  );
};

export default ShopifyFlowIcon;
